import { colorBlindMode, darkMode, highContrastMode } from '../index';
export var mode = {};
mode.colorBlind = colorBlindMode;
mode.dark = darkMode;
mode.highContrast = highContrastMode;